/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import OnTraccrTextInput from '../common/inputs/OnTraccrTextInput';
import { validateNewValue } from './searchHelpers';

export default function CustomFilterRuleInput({
  onChange,
  ruleValue,
  formulas = [],
}) {
  const [showDisplay, setShowDisplay] = useState(true);
  const [inputValue, setInputValue] = useState(ruleValue);
  const [error, setError] = useState(null);

  useEffect(() => {
    setInputValue(ruleValue);
  }, [ruleValue]);

  // Constructs display value where all relevant indices are bolded
  const displayValue = useMemo(() => {
    if (!inputValue) return <span>No custom filter rule</span>;
    let acc = '';
    const accElements = [];
    let isInt = !!parseInt(inputValue.charAt(0), 10);
    for (let i = 0; i < inputValue.length; i += 1) {
      const char = inputValue[i];
      if (!parseInt(char, 10) && !isInt) {
        acc += char;
      } else if (parseInt(char, 10) && isInt) {
        acc += char;
      } else {
        const elementType = isInt ? 'b' : 'span';
        accElements.push(
          React.createElement(elementType, { key: accElements.length }, acc)
        );
        acc = char;
        isInt = !!parseInt(char, 10);
      }
    }

    if (acc) {
      const elementType = isInt ? 'b' : 'span';
      accElements.push(
        React.createElement(elementType, { key: accElements.length }, acc)
      );
    }
    return (
      <>
        {accElements.map((element, index) => (
          <span key={index}>{element}</span>
        ))}
      </>
    );
  }, [inputValue]);

  useEffect(() => {
    const { error: validationError } = validateNewValue(inputValue, formulas);
    setError(validationError);
  }, [inputValue, formulas]);

  const onCancel = () => {
    setShowDisplay(true);
  };

  const onBlur = () => {
    onCancel();
  };

  const onInputChange = (e) => {
    const newValue = e.target.value;
    const { error: validatonError } = validateNewValue(newValue, formulas);

    setError(validatonError);
    onChange(newValue);
  };

  const cellItem = useMemo(() => {
    if (!showDisplay) {
      return (
        <OnTraccrTextInput
          onChange={onInputChange}
          onBlur={onBlur}
          autoFocus
          value={inputValue}
        />
      );
    }

    return (
      <div
        onClick={() => setShowDisplay(false)}
        style={{
          border: '1px solid #d9d9d9',
          width: 'fit-content',
          padding: '5px',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        {displayValue}
      </div>
    );
  }, [
    showDisplay,
    onChange,
    onBlur,
    displayValue,
    inputValue,
  ]);

  return (
    <div>
      {cellItem}
      {error && (
        <span style={{ color: 'red' }}>{error}</span>
      )}
    </div>
  );
}

CustomFilterRuleInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  ruleValue: PropTypes.string.isRequired,
  formulas: PropTypes.arrayOf(PropTypes.shape({})),
};

CustomFilterRuleInput.defaultProps = {
  formulas: [],
};
